import React from "react";
import ReactEcharts from "echarts-for-react";

export const StcTempChart = ({ readings }) => {
  const option = {
    grid: { left: 50, right: 20, top: 30, bottom: 40 },
    xAxis: {
      type: "time",
      axisLabel: { color: "#ccc", fontSize: 10 },
    },
    yAxis: {
      name: "Temperature",
      type: "value",
      nameTextStyle: { color: "#ccc" },
      axisLabel: { color: "#ccc" },
    },
    tooltip: {
      trigger: "axis",
      axisPointer: { type: "cross" },
      confine: true,
    },
    series: [
      {
        data: readings?.map((r) => [r.timestamp, r.temperature]),
        type: "scatter",
        symbolSize: 4,
      },
    ],
  };

  return (
    <ReactEcharts option={option} style={{ height: 280, width: "100%" }} />
  );
};
